module.exports = __webpack_public_path__ + "static/media/bettr-profiles.c8d4adba.png";